Number.prototype.numberFormat = numberFormat;
Number.prototype.inputMaskNumberFormat = inputMaskNumberFormat;

/**
 * Hàm định dạng số
 * @param {number} decimals số chữ số phần thập phân
 * @param {string} dec_point kí hiệu ngăn cách phần nguyên và phần thập phân
 * @param {string} thousands_sep kí hiệu ngăn cách phần nghìn
 * @CreatedBy NDcong 23/9/2020
 */
function numberFormat(decimals, dec_point, thousands_sep) {
  const number = this;
  // hiệu chỉnh đầu vào
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = typeof thousands_sep === 'undefined' ? '.' : thousands_sep;
  const dec = typeof dec_point === 'undefined' ? ',' : dec_point;
  const toFixedFix = function (n, prec) {
    var value = Number(Math.round(Number(n + 'e' + prec)) + 'e' + -prec);
    if (Number.isNaN(value)) {
      var precision = Math.pow(10, prec);
      value = Math.round(n * precision) / precision;
    }
    return value.toFixed(prec);
  };
  // tách group phần nguyên và phân thập phân
  const s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
  // format phần nguyên
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  // format phần thập phân
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

function inputMaskNumberFormat(decimals, dec_point, thousands_sep) {
  const number = this;
  // hiệu chỉnh đầu vào
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = typeof thousands_sep === 'undefined' ? '.' : thousands_sep;
  const dec = typeof dec_point === 'undefined' ? ',' : dec_point;
  const toFixedFix = function (n, prec) {
    var value = Number(Math.round(Number(n + 'e' + prec)) + 'e' + -prec);
    if (Number.isNaN(value)) {
      var precision = Math.pow(10, prec);
      value = Math.round(n * precision) / precision;
    }
    return value.toFixed(prec);
  };
  // tách group phần nguyên và phân thập phân
  const s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
  // format phần nguyên
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep).replace(/\d/g, '#');
  }
  // format phần thập phân
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('##');
  }
  return s.join(dec);
}
